module.exports = __webpack_public_path__ + "static/media/cd2-icon-recalled.1a005f00.svg";